import { CATEGORY, LEVELPOINTS, QUANTITY_ECOLIER } from "./constants";
import ecolierTasks from '../utils/ecolierTasks.json';
import benjaminTasks from '../utils/benjaminTasks.json';
import cadetTasks from '../utils/cadetTasks.json';
import juniorTasks from '../utils/juniorTasks.json';
import studentTasks from '../utils/studentTasks.json';



export const checkTaskListFn = (taskList, answerList) => {
    let points = 0;
    let amountCorrectAnswer = 0;
    let amountWrongAnswer = 0;
    let maxPoints = 0;
    const tasks = [];
    const taskListWithResult = taskList.map(task => {
        maxPoints += LEVELPOINTS[task.level];
        const relatedTask = answerList.find(answer => answer._id === task._id);
        let taskPoint = 0;
        if (relatedTask) {
            const relatedAnswer = task.answers.find(answer => answer.name === relatedTask.answerNameKey);
            if (!relatedAnswer) return;
            const isRight = relatedAnswer.isCorrect;
            isRight ? amountCorrectAnswer += 1 : amountWrongAnswer += 1;
            taskPoint = isRight ? LEVELPOINTS[task.level] : 0 - (LEVELPOINTS[task.level] / 4);
            points += taskPoint;
            tasks.push({ _id: relatedTask._id, answer: relatedTask.answerNameKey, taskPoint });
        }
        return { ...task, taskPoint, disabled: true };
    });
    const quizResult = {
        points,
        amountCorrectAnswer,
        amountWrongAnswer,
        amountQuestion: taskListWithResult.length,
        maxPoints,
        tasks,
    };
    return { taskListWithResult, quizResult };
};


export const calculateWeightedScore = ({ points, maxPoints, amountCorrectAnswer, amountWrongAnswer, amountQuestion, timeUsed, maxTime }) => {

    const minPoints = -maxPoints / 4;
    const normalizedPoints = (points - minPoints) / (maxPoints - minPoints);

    // Assegna pesi a ciascun parametro
    const weightCorrectAnswers = 0.4;
    const weightWrongAnswers = 0.1;
    const weightTimeUsed = 0.1;
    const weightPoints = 0.4;

    // Normalizza altri parametri
    const normalizedCorrectAnswers = amountQuestion > 0 ? amountCorrectAnswer / amountQuestion : 0;
    const normalizedWrongAnswers = amountQuestion > 0 ? amountWrongAnswer / amountQuestion : 0;
    const normalizedTimeUsed = Math.min(timeUsed / maxTime, 1); // Normalizza il tempo usato

    // Calcola il punteggio ponderato
    let weightedScore = (normalizedPoints * weightPoints) +
        (normalizedCorrectAnswers * weightCorrectAnswers) -
        (normalizedWrongAnswers * weightWrongAnswers) +
        ((1 - normalizedTimeUsed) * weightTimeUsed);

    // Assicura che il punteggio sia positivo
    weightedScore = ((weightedScore + 0.1) / 1.0) * 100; // Normalizza l'intervallo tra 0 e 100
    return parseFloat(weightedScore.toFixed(2));
};


export const createTaskWithResult = ({ amountQuestion, tasks }) => {
    // if (!amountQuestion || !tasks) [];
    let category;
    let taskListWithResult;
    if (QUANTITY_ECOLIER[`QUANTITY_${amountQuestion}`]) {
        category = CATEGORY.ECOLIER;
        taskListWithResult = tasks.reduce((acc, task) => {
            const taskCompleted = ecolierTasks.find(({ _id }) => _id === task._id);
            if (taskCompleted) {
                acc.push({ ...taskCompleted, taskPoint: task.taskPoint, disabled: true, answerNameKey: task.answer });
            }
            return acc;
        }, []);
    } else {
        category = 'other';
        const otherTasks = [...benjaminTasks, ...cadetTasks, ...juniorTasks, ...studentTasks];
        taskListWithResult = tasks.reduce((acc, task) => {
            const taskCompleted = otherTasks.find(({ _id }) => _id === task._id);
            if (taskCompleted) {
                acc.push({ ...taskCompleted, taskPoint: task.taskPoint, disabled: true, answerNameKey: task.answer });
            }
            return acc;
        }, []);

    }
    return taskListWithResult;
};

export const findTask = idTask => {
    const allTasks = [...ecolierTasks, ...benjaminTasks, ...cadetTasks, ...juniorTasks, ...studentTasks];
    return allTasks.find(task => task._id === idTask);
}

